export enum DmDocumentAssignmentTypeEnum {

   primary,
   secondary,
}